module.exports = __webpack_public_path__ + "static/img/promotion-poster.f33d0e4a.jpg";